import React, { Component } from 'react'
import PropTypes from 'prop-types'
import StyleSheet from 'styles'

export class Progress extends Component {
  static propTypes = {
    value: PropTypes.any,
    total: PropTypes.any,
    showKey: PropTypes.bool,
    totalLabel: PropTypes.string,
    valueLabel: PropTypes.string,
  }

  get progressPercent() {
    return (Number(this.props.value) / Number(this.props.total) * 100)
  }

  render = () => {
    const {totalLabel, valueLabel, showKey} = this.props
    return (
      <div className={this.props.className}>
        <div className={styles.progress}>
          <span style={{width: `${this.progressPercent}%`}}/>
        </div>

        {showKey &&
          <ul className={styles.keys}>
            <li><span className={styles('key', 'value')}/>{valueLabel}</li>
            <li><span className={styles('key', 'total')}/>{totalLabel}</li>
          </ul>
        }
    </div>
    )
  }
}

export const styles = StyleSheet({
  progress: {
    height: 15,
    width: '100%',
    overflow: 'hidden',
    backgroundColor: '#ccc',
    '& span': {
      display: 'inline-block',
      height: '100%',
      backgroundColor: '#586c7b',
    },
  },
  keys: {
    padding: '30px 0 !important',
    display: 'flex',
    '& li': {
      flex: 1,
      fontSize: 12,
    }
  },
  key: {
    width: 18,
    height: 18,
    display: 'inline-block',
    verticalAlign: 'middle',
    marginRight: 10,
    '&$value': {
      backgroundColor: '#586c7b',
    },
    '&$total': {
      backgroundColor: '#ccc',
    }
  },
  value: {},
  total: {},
})